<template>
    <header class="login-brand">
      <Logo />
  
      <h1>
        Masuk ke <span>DITAP</span>
      </h1>
  
      <p>Kelola bisnis dan ulasan pelangganmu.</p>
    </header>
  </template>
  
  <script>
  import Logo from '@/components/common/Logo.vue'
  
  export default {
    name: 'LoginHeader',
  
    components: {
      Logo
    }
  }
  </script>